import { render, staticRenderFns } from "./InvestInfo.vue?vue&type=template&id=2fbc1a3c&scoped=true&"
import script from "./InvestInfo.vue?vue&type=script&lang=js&"
export * from "./InvestInfo.vue?vue&type=script&lang=js&"
import style0 from "./InvestInfo.vue?vue&type=style&index=0&id=2fbc1a3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbc1a3c",
  null
  
)

export default component.exports